import Component from './component';

Component.defaultProps = {
    prefetch: false,
    className: null,
};
export default Component;